import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AppV1 from "./v1/AppV1";
import AppV2 from "./v2/AppV2";

function App() {
  return (
    <Router>
      <Routes>
        {/* Versioned routes */}
        <Route path="/*" element={<AppV1 />} />
        <Route path="/v2/*" element={<AppV2 />} />

        {/* Default redirect (send everything else to v1) */}
        <Route path="*" element={<Navigate to="/v1" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
